import styled from '@emotion/styled'
import { linkCSS } from '../styles/variables'

export const InlineLink = styled('a', { target: '_blank' })`
  ${linkCSS};
  padding-left: 4px;
  vertical-align: middle;
`

InlineLink.defaultProps = {
  target: '_blank',
  rel: 'noreferrer'
}

export const Link = styled(InlineLink)`
  display: block;
`